module.exports = __webpack_public_path__ + "static/japan-b88b1984ef60537e9444fb8f435cfe1b.jpg";